import React, { useState } from 'react';
import cx from 'classnames';

import { StxmapTab } from './components/Tabs/StxmapTab/StxmapTab';
import { StxsTab } from './components/Tabs/StxsTab/StxsTab';
import { TokenTab } from './components/Tabs/TokenTab/TokenTab';

type Props = {
  currentSafe: string;
};

const tabs = ['Tokens', '.stxs', '.stxmap'] as const;

type Tab = (typeof tabs)[number];

export const Stx20Tab = ({ currentSafe }: Props) => {
  const [selectedTab, setSelectedTab] = useState<Tab>('Tokens');

  return (
    <div className="flex flex-col px-16 sm:px-0 gap-24 w-full">
      <div className="flex gap-16 border-b-[.5px] border-black-4">
        {tabs.map((tab) => (
          <button
            onClick={() => setSelectedTab(tab)}
            className={cx('pb-16', tab === selectedTab && 'border-b-[2px] border-primary')}
            key={tab}
          >
            <div className={cx('text-m13 ', tab === selectedTab ? 'text-primary' : 'text-regular')}>
              {tab}
            </div>
          </button>
        ))}
      </div>
      <div className="flex flex-col gap-8">
        {selectedTab === 'Tokens' && <TokenTab currentSafe={currentSafe} />}
        {selectedTab === '.stxs' && <StxsTab currentSafe={currentSafe} />}
        {selectedTab === '.stxmap' && <StxmapTab currentSafe={currentSafe} />}
      </div>
    </div>
  );
};
